/* eslint-disable @typescript-eslint/naming-convention */
import { useFeatureFlagsStore } from '../../stores';
import { TIKTOK_ID } from '../../app-v2/constants/networks';
const useNetworkMarketplace = () => {
    const showNetworkMarketplaceInvitationBox = (brief) => {
        var _a, _b;
        // Show if creator licensing is enabled
        if (brief === null || brief === void 0 ? void 0 : brief.has_module_creator_licensing) {
            return true;
        }
        // Show if TikTok invite links feature is enabled and there's a TikTok task
        const featureFlags = useFeatureFlagsStore().data;
        const isTiktokInviteLinksEnabled = featureFlags['tiktok-invite-links-q2-2025'] || false;
        if (isTiktokInviteLinksEnabled) {
            const allTasks = [...((_a = brief === null || brief === void 0 ? void 0 : brief.tasks) !== null && _a !== void 0 ? _a : []), ...((_b = brief === null || brief === void 0 ? void 0 : brief.optional_tasks) !== null && _b !== void 0 ? _b : [])];
            const hasTiktokTask = allTasks.some((task) => task.network_id === TIKTOK_ID);
            return hasTiktokTask;
        }
        return false;
    };
    const getLatestTtocmCampaignHistory = (brief, briefs) => {
        var _a;
        if (!briefs || !(brief === null || brief === void 0 ? void 0 : brief.id)) {
            return {};
        }
        const matchingBrief = briefs.find((briefItem) => briefItem.id === brief.id);
        return (_a = matchingBrief === null || matchingBrief === void 0 ? void 0 : matchingBrief.latest_ttocm_campaign_history) !== null && _a !== void 0 ? _a : {};
    };
    return {
        showNetworkMarketplaceInvitationBox,
        getLatestTtocmCampaignHistory
    };
};
export default useNetworkMarketplace;
